'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { HelloKittyActions } from './hello-kitty-actions'
import { HelloKittyBowLogo } from './hello-kitty-bow-logo'

const lifestyleImages = [
  { image: '/image/2026/10/14/hk_lifestyle_1_v2.jpg', labelKey: 'item1' },
  { image: '/image/2026/10/14/hk_lifestyle_2_v2.jpg', labelKey: 'item2' },
  { image: '/image/2026/10/14/hk_lifestyle_3_v2.jpg', labelKey: 'item3' },
]

const MOBILE_AUTOPLAY = {
  delay: 3000,
  stopOnInteraction: false,
  breakpoints: { '(min-width: 1024px)': { active: false } },
}

export const HelloKittyLifestyle = () => {
  const t = useTranslations('hello_kitty_hardcode.lifestyle')

  return (
    <section className='grid gap-6 bg-[#FAF5EF] px-5 py-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,59.25%)] lg:items-center lg:gap-10 lg:py-0 lg:pl-15 lg:pr-0'>
      <div className='grid gap-6'>
        <div className='grid gap-2'>
          <HelloKittyBowLogo />
          <h2 className='font-criteria text-4xl font-bold uppercase leading-[47px] tracking-[-0.02em] text-neutral-900 lg:text-5xl lg:leading-[1.1] lg:tracking-[-0.03em] 2xl:text-[72px] 2xl:leading-[80px]'>
            {t('title_line1')}
            <br />
            <span className='text-[#C20019]'>{t('title_line2')}</span>
          </h2>
        </div>
        <p className='text-base text-[#242424] lg:text-[22px] lg:leading-[30px]'>
          {t('description_line1')} <br className='max-lg:hidden' />
          {t('description_line2')}
        </p>
        <HelloKittyActions />
      </div>

      {/* Mobile: slide ngang tự chạy, desktop: tắt slide, 3 ảnh ghép liền nhau */}
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          breakpoints: { '(min-width: 1024px)': { active: false } },
        }}
        plugins={[Autoplay(MOBILE_AUTOPLAY)]}
        className='w-full'
      >
        <CarouselContent className='ml-0'>
          {lifestyleImages.map((item) => (
            <CarouselItem
              key={item.labelKey}
              className='basis-[73%] pl-0 lg:basis-1/3'
            >
              <div className='relative aspect-[245/400] lg:aspect-[367/600]'>
                <Image
                  src={ImageHelper.getImageUrlCdn(item.image)}
                  alt={t(`images.${item.labelKey}`)}
                  fill
                  sizes='(min-width: 1024px) 20vw, 73vw'
                  className='object-cover'
                />
                <div className='absolute inset-0 bg-gradient-to-b from-black/20 to-transparent to-25% max-lg:hidden' />
                <p className='absolute bottom-4 left-3 font-criteria text-lg uppercase leading-[26px] tracking-[-0.02em] text-white [text-shadow:0_2px_4px_rgba(0,0,0,0.25)] lg:bottom-auto lg:left-5 lg:top-5'>
                  {t(`images.${item.labelKey}`)}
                </p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  )
}
